import { render } from "./PortalHomeUltimosInformesCard.vue?vue&type=template&id=5cdfc460&scoped=true"
import script from "./PortalHomeUltimosInformesCard.vue?vue&type=script&lang=js"
export * from "./PortalHomeUltimosInformesCard.vue?vue&type=script&lang=js"

import "./PortalHomeUltimosInformesCard.vue?vue&type=style&index=0&id=5cdfc460&scoped=true&lang=css"
import "./PortalHomeUltimosInformesCard.vue?vue&type=style&index=1&id=5cdfc460&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdfc460"]])

export default __exports__